
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Collapse,
  Stack,
  Typography,
  useTheme,
  Zoom,
  Tooltip,
} from "@mui/material";
import Icon from "../../../../Icon/Icon";
import { ChipInfo } from "../../../../MainComponents/ChipInfo/ChipInfo";
import { useConstants } from "../Main/useConstants";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import { InvestigationButton } from "../components/InvestigationButton";
import { InvolvedDetails } from "./InvolvedDetails";


// Involucrado para la vista en la lista
export const InvolvedView = ({
  index,
  color,
  involved,
  setSelectedInvolved,
  setShowDrawer,
  setDrawerInEdit,
  onValidateSoeid,
  justView,
  hide,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const { enums, functions } = useConstants();

  // El detalle se despliega aqui mismo; el boton lleva directo a editar
  const [expanded, setExpanded] = useState(false);

  // Ya se valido contra el servicio: el boton pasa a verde con palomita
  const isSoeidValidated =
    !!involved?.soeid && typeof involved.soeid === "object";

  const handleEdit = (event) => {
    event.stopPropagation();
    setSelectedInvolved({...involved, index});
    setDrawerInEdit?.(true);
    setShowDrawer(true);
  }

  if (hide) return <></>;

  return (
    <InvestigationItemContainer
      color={color}
      sx={{ padding: 2 }}
    >
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography fontSize={16} fontWeight={600} color={color} >
            {involved.name}
          </Typography>
          <Tooltip
            title={
              involved.confirm_text === "confirmed" ?
              t("involved.confirmed") :
              involved.confirm_text === "cant_confirm" ?
              t("involved.not_confirmed") :
              involved.confirm_text === "out" ?
              t("involved.not_participated") :
              involved.confirm_text === true ?
              t("involved.confirmed") :
              t("involved.pending_confirmation")
            }
            placement="bottom"
            arrow
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 150 }}
          >
            <Box ml={.5}>
              <Icon
                name={
                  involved.confirm_text === "confirmed" ?
                  "bold_tick_circle" :
                  involved.confirm_text === "cant_confirm" ?
                  "bold_danger" :
                  involved.confirm_text === "out" ?
                  "bold_close_circle" :
                  involved.confirm_text === true ?
                  "bold_tick_circle" :
                  "bold_info_circle"
                }
                color={
                  involved.confirm_text === "confirmed" ?
                  theme.palette.green.main :
                  involved.confirm_text === "cant_confirm" ?
                  theme.palette.orange.main :
                  involved.confirm_text === "out" ?
                  theme.palette.red.main :
                  involved.confirm_text === true ?
                  theme.palette.green.main :
                  theme.palette.yellow.main
                }
                size={16}
              />
            </Box>
          </Tooltip>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <ChipInfo
            label={
              <span style={{ color: theme.palette.blueGray.main }}>
                {t("involved.indicated_by")}: &nbsp;
                  <b style={{ color: theme.palette.oxfordBlue.main }}>
                    {
                      (involved.indicated?.from === involved.added) ?
                      functions.getUserLabel({ from: enums.typeUser.COMPLAINANT }) :
                      functions.getUserLabel(involved?.indicated) ?? "Otro"
                    }
                  </b>
              </span>
            }
            icon={<Icon name="bold_user_receive" size={24} />}
            color="secondary"
            maxWidth={200}
          />
          {
            !justView &&
            <Tooltip
              title={t("involved.edit")}
              placement="bottom"
              arrow
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 150 }}
            >
              <span>
                <InvestigationButton
                  icon="outline_edit"
                  variant="primary"
                  onClick={handleEdit}
                />
              </span>
            </Tooltip>
          }
          {
            !justView &&
            <Tooltip
              title={
                isSoeidValidated
                  ? t("involved.soeid_already_validated")
                  : t("involved.validate_soeid")
              }
              placement="bottom"
              arrow
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 150 }}
            >
              <span>
                <InvestigationButton
                  icon={isSoeidValidated ? "bold_user_tick" : "outline_user_search"}
                  variant={isSoeidValidated ? "success" : "primary"}
                  onClick={() => onValidateSoeid?.({ ...involved, index })}
                  // El color del Icon no alcanza los paths internos del svg
                  sx={
                    isSoeidValidated
                      ? { "& svg, & svg *": { fill: theme.palette.common.white } }
                      : undefined
                  }
                />
              </span>
            </Tooltip>
          }
        </Stack>
      </Box>

      {/* Afordance explicita: dice que hay debajo y si esta abierto o cerrado */}
      <Box
        component="button"
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded((prev) => !prev)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          marginTop: 1,
          padding: 0,
          border: "none",
          background: "none",
          cursor: "pointer",
          color: theme.palette.blueGray.main,
          "&:hover": { color: theme.palette.ethicsBlue.main },
          "& svg, & svg *": { fill: "currentColor" },
        }}
      >
        <Typography fontSize={13} fontWeight={600} color="inherit">
          {t("involved.collaborator_details")}
        </Typography>
        <Icon
          name="arrow_down_2"
          size={10}
          style={{
            transition: "transform 150ms ease-in-out",
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Box>

      <Collapse in={expanded} unmountOnExit>
        <Box marginTop={1}>
          <InvolvedDetails involved={involved} columns={2} underline={false} />
        </Box>
      </Collapse>
    </InvestigationItemContainer>
  )
};
